import { Alert } from '@/components/ui/Alert'
import { Button } from '@/components/ui/Button'
import { Modal } from '@/components/ui/Modal'

const IMPACT_NOTICE =
  '운영시간을 줄이면 그 시간대의 새 예약이 막혀요. 이미 확정된 예약은 그대로 유지되며 취소되지 않아요.'

/**
 * 저장 전 변경 영향 확인 모달(요구사항). 변경 여부와 무관하게 매 저장 시도마다 노출한다 — 서버에
 * "무엇이 바뀌는지" 미리 알려주는 diff API 가 없어(설계 §2-2 자율 결정) 정확한 변경분 계산은 하지 않는다.
 */
export function CourtOperatingHourSaveConfirmModal({
  upcomingReservationCount,
  isPending,
  onCancel,
  onConfirm,
}: {
  /** 앞으로 남은 점유 예약 수. 0 초과면 문구에 포함한다. */
  upcomingReservationCount: number
  isPending: boolean
  onCancel: () => void
  onConfirm: () => void
}) {
  return (
    <Modal title="운영시간 변경사항 저장" onClose={onCancel}>
      <div className="space-y-4">
        <Alert tone="warning">
          <p>{IMPACT_NOTICE}</p>
          {upcomingReservationCount > 0 ? (
            <p className="mt-1">현재 앞으로 남은 예약이 {upcomingReservationCount}건 있습니다.</p>
          ) : null}
        </Alert>
        <p className="text-sm text-slateish-600">변경사항을 저장할까요?</p>

        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="secondary" onClick={onCancel}>
            취소
          </Button>
          <Button type="button" disabled={isPending} onClick={onConfirm}>
            {isPending ? '저장하는 중…' : '저장'}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
